module.exports = __webpack_public_path__ + "static/media/9_of_clubs.310e11f1.png";